<!-- Welcome Modal -->
@if (tourService.showWelcome()) {
  <div class="tour-backdrop">
    <div class="tour-welcome-modal">
      <h2>{{ 'tour.welcome.title' | translate }}</h2>
      <p class="tour-subtitle">{{ 'tour.welcome.subtitle' | translate }}</p>

      <!-- Language selector -->
      <div class="tour-lang-section">
        <span class="tour-lang-label">🌐</span>
        <div class="tour-lang-grid">
          @for (lang of languages; track lang.code) {
            <button
              class="tour-lang-btn"
              [class.active]="languageService.currentLang() === lang.code"
              (click)="languageService.setLanguage(lang.code)"
              [title]="lang.name">
              <span class="tour-lang-flag">{{ lang.flag }}</span>
              <span class="tour-lang-name">{{ lang.name }}</span>
            </button>
          }
        </div>
      </div>

      <div class="tour-welcome-actions">
        <button mat-raised-button color="accent" (click)="tourService.start()">
          {{ 'tour.welcome.cta' | translate }}
        </button>
        <button mat-button (click)="tourService.skip()">
          {{ 'tour.welcome.skip' | translate }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Active Tour Overlay -->
@if (tourService.isActive()) {
  <!-- Backdrop with spotlight cutout -->
  <div class="tour-backdrop-overlay"
       [style.--spot-top.px]="spotlightTop()"
       [style.--spot-left.px]="spotlightLeft()"
       [style.--spot-w.px]="spotlightWidth()"
       [style.--spot-h.px]="spotlightHeight()">
  </div>

  <!-- Spotlight outline (pulses when interactive) -->
  <div class="tour-spotlight"
       [class.interactive]="tourService.currentStepData()?.interactive"
       [style.top.px]="spotlightTop()"
       [style.left.px]="spotlightLeft()"
       [style.width.px]="spotlightWidth()"
       [style.height.px]="spotlightHeight()">
  </div>

  <!-- Tooltip card -->
  <div class="tour-tooltip"
       [style.top.px]="tooltipTop()"
       [style.left.px]="tooltipLeft()">

    <!-- Header -->
    <div class="tour-tooltip-header">
      <div class="tour-step-info">
        <span class="tour-step-counter">
          {{ 'tour.stepOf' | translate:{current: tourService.currentStep() + 1, total: tourService.totalSteps()} }}
        </span>
        @if (tourService.currentStepData()?.isPro) {
          <span class="tour-pro-badge">{{ 'tour.proBadge' | translate }}</span>
        }
      </div>
      <h3 class="tour-step-title">{{ (tourService.currentStepData()?.titleKey || '') | translate }}</h3>
    </div>

    <!-- Body -->
    <div class="tour-tooltip-body">
      <p class="tour-step-desc">{{ (tourService.currentStepData()?.descKey || '') | translate }}</p>

      @if (!isMobile()) {
        <ul class="tour-features">
          @for (f of tourService.currentStepData()?.features ?? []; track f.titleKey) {
            <li class="tour-feature-item">
              <span class="tour-feature-icon">{{ f.icon }}</span>
              <div class="tour-feature-text">
                <strong>{{ f.titleKey | translate }}</strong>
                <span>{{ f.textKey | translate }}</span>
              </div>
            </li>
          }
        </ul>
      }
    </div>

    <!-- "Try it" hint for interactive steps -->
    @if (tourService.currentStepData()?.interactive) {
      <div class="tour-try-it">{{ 'tour.tryIt' | translate }}</div>
    }

    <!-- Footer -->
    <div class="tour-tooltip-footer">
      <div class="tour-dots">
        @for (step of tourService.steps; track step.id; let i = $index) {
          <span class="tour-dot" [class.active]="i === tourService.currentStep()"></span>
        }
      </div>
      <div class="tour-nav-buttons">
        <button mat-button (click)="tourService.skip()" class="tour-skip-btn">
          {{ 'tour.skip' | translate }}
        </button>
        @if (tourService.currentStep() > 0) {
          <button mat-stroked-button (click)="tourService.back()">
            {{ 'tour.back' | translate }}
          </button>
        }
        <button mat-raised-button color="accent" (click)="tourService.next()">
          {{ tourService.currentStep() < tourService.totalSteps() - 1
              ? ('tour.next' | translate)
              : ('tour.finish' | translate) }}
        </button>
      </div>
    </div>
  </div>
}

<!-- Final Modal -->
@if (tourService.showFinal()) {
  <div class="tour-backdrop">
    <div class="tour-final-modal">
      <h2>{{ 'tour.final.heading' | translate }}</h2>
      <p>{{ 'tour.final.subtext' | translate }}</p>

      <button mat-raised-button color="accent" class="tour-signup-btn" (click)="goRegister()">
        {{ 'tour.final.signupBtn' | translate }}
      </button>

      <mat-divider style="margin: 24px 0;"></mat-divider>

      <!-- Feedback section -->
      <h4>{{ 'tour.final.feedbackHeading' | translate }}</h4>
      @if (!feedbackSent()) {
        <div class="tour-feedback-form">
          <input
            class="tour-input"
            type="email"
            [placeholder]="'tour.final.feedbackEmail' | translate"
            [ngModel]="feedbackEmail()"
            (ngModelChange)="feedbackEmail.set($event)">
          <textarea
            class="tour-textarea"
            rows="3"
            [placeholder]="'tour.final.feedbackPlaceholder' | translate"
            [ngModel]="feedbackMessage()"
            (ngModelChange)="feedbackMessage.set($event)">
          </textarea>
          <button mat-stroked-button (click)="submitFeedback()" [disabled]="feedbackLoading()">
            {{ 'tour.final.feedbackSubmit' | translate }}
          </button>
        </div>
      } @else {
        <p class="tour-feedback-success">{{ 'tour.final.feedbackSuccess' | translate }}</p>
      }

      <button mat-button (click)="tourService.skip()" style="margin-top: 16px;">
        {{ 'common.close' | translate }}
      </button>
    </div>
  </div>
}
